const ru = require('./ru');
const en = require('./en');
module.exports = {
  ru,
  en
};
